import React from 'react';
import { Stack, Box } from '@mui/material';

const Descripcion = (props) => {
  const { B } = props;

  return (
    <Stack alignItems="center" sx={{ py: 5, px: '5%'}}>
      <Stack  sx={{ maxWidth: '1200px', width: '100%' }} spacing={2} >
        <Box sx={{ textAlign: 'justify' }}>
        <B>Líderes en Movimiento (LeM)</B> es un programa académico extracurricular del Consejo Mexicano de Negocios (CMN)
        e implementado por El Colegio de México (COLMEX). LeM busca identificar a <B>jóvenes mexicanos con talento</B> intelectual 
        sobresaliente, <B>potencial de liderazgo</B> y un <B>fuerte compromiso social</B> con su comunidad y el país.
        </Box>
        <Box sx={{ textAlign: 'justify' }}>
        En este 2026, LeM Universitarios seleccionará a 60 estudiantes, quienes accederán de manera gratuita a conferencias, talleres, cursos en
línea, mentorías personalizadas, espacios para crear soluciones a problemáticas reales y dos viajes académicos (uno nacional y otra
internacional), a fin de impulsar su talento para convertirse en líderes capaces de generar impacto social en un mundo complejo.
        </Box>
      </Stack>
    </Stack>
  );
};

export default Descripcion;
